module.exports = __webpack_public_path__ + "img/lyon.a9fb09dd.png";